import React from 'react';
import {
  Box,
  MenuItem,
  Select,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LANGUAGE_STORAGE_KEY, normalizeLanguage, SupportedLanguage } from '../../i18n';
import { LANGUAGE_OPTIONS } from '../../i18n/languages';
import { getLanguagePreferenceName } from '../../i18n/languages';

const LanguageSwitcher: React.FC<{ compact?: boolean }> = ({ compact = false }) => {
  const { i18n, t } = useTranslation();
  const language = normalizeLanguage(i18n.resolvedLanguage || i18n.language);

  const setLanguage = (value: SupportedLanguage) => {
    if (value === language) {
      return;
    }

    localStorage.setItem(LANGUAGE_STORAGE_KEY, value);
    document.documentElement.lang = value;
    void i18n.changeLanguage(value);
    if (localStorage.getItem('nadiAstroToken')) {
      fetch('/api/users/profile', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('nadiAstroToken')}` },
        body: JSON.stringify({ preferences: { language: getLanguagePreferenceName(value) } }),
      }).catch(() => {});
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        border: '1px solid rgba(255, 255, 255, 0.45)',
        borderRadius: 1.5,
        px: compact ? 0.4 : 0.6,
        py: 0.25,
        gap: 0.35,
      }}
      aria-label={t('common.language')}
    >
      <Select
        size="small"
        value={language}
        onChange={(event) => setLanguage(event.target.value as SupportedLanguage)}
        renderValue={(value) => LANGUAGE_OPTIONS.find((option) => option.code === value)?.shortLabel || 'EN'}
        sx={{
          minWidth: compact ? 58 : 72,
          color: 'inherit',
          '& .MuiSelect-select': { py: compact ? 0.35 : 0.5, px: compact ? 0.75 : 1, fontWeight: 800 },
          '& .MuiOutlinedInput-notchedOutline': { borderColor: 'transparent' },
          '& .MuiSvgIcon-root': { color: 'inherit' },
        }}
      >
        {LANGUAGE_OPTIONS.map((option) => (
          <MenuItem key={option.code} value={option.code}>{option.label}</MenuItem>
        ))}
      </Select>
    </Box>
  );
};

export default LanguageSwitcher;
